module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-list-wrap"
  }, _vm._l((_vm.show_list_opt_data), function(item, key) {
    return _c(_vm.box_type(item), {
      key: key,
      ref: item.right_id,
      refInFor: true,
      tag: "box",
      attrs: {
        "check_data": _vm.right_ids,
        "box_data": item
      },
      on: {
        "check_change": _vm.data_change
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-233f2b88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authList.vue
// module id = 1084
// module chunks = 1